import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RotateLeftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rotate_left"}/>
}
